import { Page } from '@/core/architecture'

import { ConsoleEventDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleEventDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleEventDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleEventDetailTemplate state={state} {...actions} />
}
